import moment from 'moment';
import { setRootValue } from 'v2/modules/withRunForm/redux/actions';
import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelectState } from 'v3/common/components/DatePicker/DateRange/useSelectState';
import { predefinedRanges } from 'v3/common/components/DatePicker/DateRange/utility';

export const useCalendar = ({
  startDate,
  endDate,
  setIsComponentVisible,
  onCloseRightContent,
}: {
  startDate: Date | null;
  endDate: Date | null;
  setIsComponentVisible: (visible: boolean) => void;
  onCloseRightContent: () => void;
}) => {
  const dispatch = useDispatch();
  const { calendarStartDate, calendarEndDate } = useSelectState();

  const [tempDates, setTempDates] = useState({
    start: startDate,
    end: endDate,
  });

  const { start, end } = tempDates;
  const ranges = useMemo(
    () => predefinedRanges(calendarStartDate, calendarEndDate),
    [calendarStartDate, calendarEndDate]
  );

  const handleDateChange = (type: 'start' | 'end', date: Date, fn: () => void) => {
    setTempDates((prev) => {
      const newDates = { ...prev };

      if (type === 'start') {
        newDates.start = date;
        if (prev.end && date > prev.end) {
          newDates.end = date;
        }
      } else {
        newDates.end = date;
        if (prev.start && date < prev.start) {
          newDates.start = date;
        }
      }

      return newDates;
    });

    fn();
  };

  const onApply = () => {
    dispatch(
      setRootValue({
        startDate: moment(start).format('YYYY-MM-DD'),
        endDate: moment(end).format('YYYY-MM-DD'),
      })
    );
    setIsComponentVisible(false);
  };

  return {
    handleDateChange,
    onApply,
    ranges,
    start,
    end,
    calendarStartDate,
    calendarEndDate,
    onCloseCalendar: () => {
      setIsComponentVisible(false);
      onCloseRightContent();
    },
  };
};
